import React from "react";
import { connect } from "react-redux";
import BaseButton from "../BaseButton";
import SupportingText from "../SupportingText";
import { logout } from "../redux/actionCreators";

const mapDispatchToProps = dispatch => ({
  handleLogout: () => dispatch(logout())
});

class LogoutContainer extends React.Component {
  handleLogout = () => {
    const { handleLogout } = this.props;
    handleLogout();
  };
  render() {
    return (
      <div className="w-full h-full flex items-center justify-center bg-blue-darker rounded uppercase">
        <BaseButton className="w-full" onClick={() => this.handleLogout()}>
          <SupportingText textColor="white" fontWeight="thin" textSize="base">
            Logout
          </SupportingText>
        </BaseButton>
      </div>
    );
  }
}

export default connect(null, mapDispatchToProps)(LogoutContainer);



// WEBPACK FOOTER //
// ./src/LogoutContainer/LogoutContainer.js